import { render, staticRenderFns } from "./CopyTextCustomButton.vue?vue&type=template&id=0b1c7020&scoped=true"
import script from "./CopyTextCustomButton.vue?vue&type=script&lang=js"
export * from "./CopyTextCustomButton.vue?vue&type=script&lang=js"
import style0 from "./CopyTextCustomButton.vue?vue&type=style&index=0&id=0b1c7020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c7020",
  null
  
)

export default component.exports